import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

type SectorData = {
  industry: string;
  market_dynamics: string;
  regulatory_environment: string;
  customer_type: string;
  competitive_landscape: string;
};

type SaveContextRequest = {
  brand_role: string;
  sector: SectorData;
  strategic_orientation: string;
  operating_constraints?: Record<string, unknown>;
  metadata?: Record<string, unknown>;
};

const useSaveContext = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: SaveContextRequest) => saveContext(request),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['users'] });
      void queryClient.invalidateQueries({ queryKey: ['strategic_contexts'] });
    },
  });
};

export default useSaveContext;

async function saveContext(request: SaveContextRequest): Promise<{ context_id: string }> {
  const { data, error } = await supabaseClient.functions.invoke('save-context', { body: request });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();
    throw new Error(errorResponse.errors.join(', '));
  }

  return data.data;
}
